<template>
    <div
        :class="[
            variants[variant].wrapperClasses,
            { 'opacity-40 grayscale': isDisabled },
        ]"
        class="relative"
    >
        <input
            @change="valueChange"
            type="radio"
            :name="inputName"
            :value="inputValue"
            :checked="isChecked"
            :disabled="isDisabled"
            :style="[ hasTwoColors ? '' : variants[variant].backgroundStyles ]"
            :class="[
                variants[variant].backgroundClasses,
                { 'cursor-not-allowed': isDisabled },
                { 'bg-gray-light': noThanks },
                'w-full h-full rounded-full',
                'focus:outline-none focus:ring-1 focus:ring-black focus:border-black ring-offset-2',
            ]"
            :aria-label="label"
            :title="label"
            @click="clicked($event)"
        >

        <span
            v-if="hasTwoColors"
            class="pointer-events-none"
        >
            <span
                class="absolute top-0 left-0 half-cirle-left"
                :style="{ backgroundColor: inputColor }"
            ></span>
            <span
                class="absolute top-0 left-1/2 half-cirle-right"
                :style="{ backgroundColor: inputColorSecondary }"
            ></span>
        </span>

        <transition name="cz3__fade">
            <img
                v-if="isChecked && showCheckmark"
                src="../../assets/images/icons/check-item.svg"
                width="24"
                height="24"
                alt="check mark"
                :class="[ variant === 'small' ? '-bottom-3 -right-2' : 'top-3 right-3' ]"
                class="absolute pointer-events-none m-1 border border-white rounded-full"
            >
        </transition>

        <p
            v-if="noThanks"
            class="absolute top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2 capitalize font-medium whitespace-nowrap pointer-events-none"
        >
            {{ label }}
        </p>

        <span
            v-if="isDebugMode && debugValue"
            class="absolute right-0 top-0 inline-flex items-center rounded-full bg-red px-2 pt-1.5 pb-0 text-xs font-medium text-white"
        >
            {{ debugValue }}
        </span>

        <!-- Prevent image jumping -->
        <div
            v-if="isChecked"
            class="absolute pointer-events-none -left-px -top-px -right-px -bottom-px border-2 border-black"
            :class="[ variant === 'small' ? 'rounded-full' : '' ]"
        >
        </div>
    </div>
</template>

<style lang="scss" scoped>
    #cz3.cz3 {
        .half-cirle-left {
            width: 25px;
            height: 50px;
            border-top-left-radius: 25px;
            border-bottom-left-radius: 25px;
            border-right: 1px solid #dfdedd;
        }

        .half-cirle-right {
            width: 25px;
            height: 50px;
            border-top-right-radius: 25px;
            border-bottom-right-radius: 25px;
        }
    }
</style>

<script>
    import allStores from '../../stores/all';

    export default {
        mixins: [allStores],

        props: {
            showCheckmark: {
                type: Boolean,
                default: true,
            },
            isDisabled: {
                type: Boolean,
                default: false,
            },
            disabledReason: String,
            disabledReasonBody: String,
            selected: {
                type: Boolean,
                required: false,
            },
            inputName: {
                type: String,
                required: true,
            },
            inputValue: {
                type: String,
                required: true,
            },
            inputColor: {
                type: String,
                required: false,
            },
            inputColorSecondary: {
                type: String,
                required: false,
            },
            inputImage: {
                type: String,
                required: false,
            },
            variant: {
                type: String,
                default: 'large',
            },
            label: {
                type: String,
            },
            debugValue: {
                type: String,
            },
            noThanks: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                variants: {
                    small: {
                        wrapperClasses: 'w-[52px] h-[52px] rounded-full border border-gray-light',
                        backgroundStyles: {
                            backgroundColor: this.inputColor,
                            backgroundImage: `url(${this.inputImage})`,
                        },
                        backgroundClasses: 'bg-contain bg-no-repeat bg-center',
                    },
                    smallSquare: {
                        wrapperClasses: 'w-[52px] h-[52px] border border-gray-light',
                        backgroundStyles: {
                            backgroundColor: this.inputColor,
                            backgroundImage: `url(${this.inputImage})`,
                        },
                        backgroundClasses: 'bg-contain bg-no-repeat bg-center',
                    },
                    medium: {
                        wrapperClasses: 'w-[78px] h-[78px] xs:w-[84px] xs:h-[84px]',
                        backgroundStyles: {
                            backgroundColor: this.inputColor,
                            backgroundImage: `url(${this.inputImage})`,
                        },
                        backgroundClasses: 'bg-cover bg-center bg-no-repeat',
                    },
                    large: {
                        wrapperClasses: 'w-36 h-36 sm:w-44 sm:h-44',
                        backgroundStyles: {
                            backgroundColor: this.inputColor,
                            backgroundImage: `url(${this.inputImage}`,
                        },
                        backgroundClasses: 'bg-cover bg-center bg-no-repeat',
                    },
                    full: {
                        wrapperClasses: 'w-full h-40',
                        backgroundStyles: {
                            backgroundColor: this.inputColor,
                            backgroundImage: `url(${this.inputImage}`,
                        },
                        backgroundClasses: 'bg-cover bg-center bg-no-repeat',
                    },
                    fullContain: {
                        wrapperClasses: 'w-full h-40 rounded-full',
                        backgroundStyles: {
                            backgroundColor: this.inputColor,
                            backgroundImage: `url(${this.inputImage}`,
                        },
                        backgroundClasses: 'bg-contain bg-center bg-no-repeat',
                    },
                },
            };
        },

        computed: {
            isChecked() {
                return this.selected;
            },

            isDebugMode() {
                return this.customizerStore.options.debugMode;
            },

            hasTwoColors() {
                return this.variant === 'small' && this.inputColorSecondary;
            },
        },

        methods: {
            valueChange(event) {
                this.$emit('valueChange', event.srcElement.value);
            },

            clicked(event) {
                if (this.isDisabled) {
                    event.preventDefault();
                    event.stopPropagation();

                    // eslint-disable-next-line no-alert
                    alert('hi!');
                }
            },
        },
    };
</script>
